/**
 * Upcoming Events Section JavaScript
 * Handles carousel initialization if needed
 */

(function() {
  'use strict';

  // Initialize upcoming events section
  function initUpcomingEvents() {
    // The slider-element custom element handles carousel functionality automatically
    // No additional initialization needed unless custom behavior is required
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpcomingEvents);
  } else {
    initUpcomingEvents();
  }
})();
